import angular from 'angular';
import {
  userService,
  loaderService,
  ssDialogService,
  riskDataService,
  riskSharedModelService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import editRiskDialog from '../dialog.editRiskDialog';
import controller from './risk.controller';
import directive from './risk.directive';
import deleteRiskConfirmDialog from '../dialog.deleteRiskConfirmDialog';
import syncRiskConfirmDialog from '../dialog.syncRiskConfirmDialog';


const riskModule = angular.module('app.components.admin.risk', [
  userService,
  alerts,
  actionIcon,
  confirmDialog,
  editRiskDialog,
  loaderService,
  ssDialogService,
  riskDataService,
  riskSharedModelService,
  controlDataService,
  controlSharedModelService,
  deleteRiskConfirmDialog,
  syncRiskConfirmDialog
])
  .directive('risk', directive)
  .controller('RiskController', controller);

export default riskModule.name;

console.log('app.components.admin.risk created');
